import { Component } from '@angular/core';

@Component({
  selector: 'app-404-not-found',
  templateUrl: './404-not-found.component.html',
  styleUrls: ['./404-not-found.component.css'],
})
export class NotFoundComponent {}
